import { Division } from '@app/constants';
import { SortOption } from './sort-option';

export const createSortOptions = (division: Division): SortOption[] => {
  const sortOptions = [
    { label: 'workOrderList.sortWorkOrderNumberAsc', field: 'workOrderNo', direction: 'asc' },
    { label: 'workOrderList.sortWorkOrderNumberDesc', field: 'workOrderNo', direction: 'desc' },
    { label: 'workOrderList.sortEstStartDateAsc', field: 'estimatedStartDate', direction: 'asc' },
    { label: 'workOrderList.sortEstStartDateDesc', field: 'estimatedStartDate', direction: 'desc' },
    { label: 'workOrderList.sortEstFinishDateDesc', field: 'estimatedFinishDate', direction: 'desc' },
    { label: 'workOrderList.sortEstFinishDateAsc', field: 'estimatedFinishDate', direction: 'asc' },
    { label: 'workOrderList.sortEstHoursDesc', field: 'estimatedHours', direction: 'desc' },
    { label: 'workOrderList.sortEstHoursAsc', field: 'estimatedHours', direction: 'asc' },
  ] as SortOption[];

  return sortOptions;
};
